import * as React from "react";
const IconAttachment = (props) => (
  <svg
    width={props.width ?? 24}
    height={props.height ?? 24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.9863 7.3258L9.65299 12.6591C8.91661 13.3955 8.91661 14.5894 9.65299 15.3258C10.3894 16.0622 11.5833 16.0622 12.3197 15.3258L17.653 9.99247C19.1258 8.51971 19.1258 6.1319 17.653 4.65914C16.1802 3.18638 13.7924 3.18638 12.3197 4.65914L6.98632 9.99247C4.77718 12.2016 4.77718 15.7833 6.98632 17.9925C9.19546 20.2016 12.7772 20.2016 14.9863 17.9925L20.3197 12.6591"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconAttachment;
